const CHATWOOT_BRAND_PATTERN = /(^|[^\w.@])Chatwoot(?![\w]|\.[A-Za-z])/g;
const RESPOND_IO_BRAND_PATTERN = /(?:www\.)?respond\.io/gi;
const RESPOND_EXAMPLE_PATTERN = /((?:e\.g\.?|مثال:)\s*)respond\b/gi;

export const replaceBrandNames = (text, installationName) => {
  if (typeof text !== 'string' || !installationName) return text;

  return text
    .replace(CHATWOOT_BRAND_PATTERN, (_, prefix) => {
      return `${prefix}${installationName}`;
    })
    .replace(RESPOND_IO_BRAND_PATTERN, installationName)
    .replace(RESPOND_EXAMPLE_PATTERN, (_, prefix) => {
      return `${prefix}${installationName}`;
    });
};

export const replaceGlobalBrandNames = text =>
  replaceBrandNames(text, window.globalConfig?.INSTALLATION_NAME);
